// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wyRX","col":"styles_col__1Ysu5"};